/*******************************************************************************
 * Copyright (c) 2023 GetChkd
 *
 * All rights reserved.
 *
 * Contributors:
 *  James Worthington - Initial implementation
 *  Amina Rais - Massive Improvements
 *  Version: 2.0.0
 *
 *******************************************************************************/


import * as React from 'react';
import { useDispatch } from 'react-redux';
import { Formik } from 'formik';
import { Typography } from '@mui/material';
import * as Yup from 'yup';
import { toast } from 'react-toastify';
import { useParams } from 'react-router-dom';
import OrgUserForm from './OrgUserForm';
import { createOrgUsers } from '../../../../../../../services/organization/OrgUsers';
import { getAllOrgsUsers, getAllOrgsUsersByOrgID } from '../../../../../../../store/reducers/organization/orgUsers/orgUsersAction';

const OrgUserCreation = ({ handleClose }) => {
    const { orgid } = useParams();
    const dispatch = useDispatch()
    const handleSubmit = async ({ organizationID, getChkdID, roleID }) => {
        try {
            await createOrgUsers({ organizationID, getChkdID, roleID });
            toast.success('Organization User was registred successfully');
            handleClose();
            if (orgid?.length > 0) {
                await dispatch(getAllOrgsUsersByOrgID({ 'organizationID': orgid })).unwrap()

            } else {
                await dispatch(getAllOrgsUsers()).unwrap();
            }
        } catch (error) {
            toast.error(error?.response?.data?.error?.message);
        }
    }

    return (
        <>
            <Typography variant='h2' color="primary" align='center' style={{ margin: '30px' }}>Organization User Registration</Typography>
            <Formik
                initialValues={{
                    organizationID: orgid ? orgid : '',
                    getChkdID: '',
                    roleID: ''
                }}
                validationSchema={Yup.object().shape({
                    organizationID: Yup.string().required('Organization is required.'),
                    getChkdID: Yup.string().required('User is required.'),
                    roleID: Yup.string().required('Role is required.')

                })}
                onSubmit={(
                    values
                ) => {
                     handleSubmit(values)
                }
                }
            >
                {({ values, handleBlur, handleChange, isSubmitting, setFieldValue, errors, touched }) => (
                    <OrgUserForm
                        values={values}
                        handleBlur={handleBlur}
                        handleChange={handleChange}
                        setFieldValue={setFieldValue}
                        isSubmitting={isSubmitting}
                        handleClose={handleClose}
                        errors={errors}
                        touched={touched} />
                )}
            </Formik>
        </>
    )

}


export default OrgUserCreation;
